import React from 'react';
import PropTypes from 'prop-types';

// Переключатель-тумблер (.sp-tg) для настроек задания/лимитов.
export default function SpiteToggle({ label, checked, onChange, full }) {
    return (
        <div
            className={`sp-tg${checked ? ' on' : ''}${full ? ' sp-tg-full' : ''}`}
            role="button"
            tabIndex={0}
            onClick={onChange}
            onKeyDown={(e) => { if (e.key === 'Enter') onChange(); }}
        >
            <span className="lab">{label}</span>
            <span className="sw" />
        </div>
    );
}

SpiteToggle.propTypes = {
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    full: PropTypes.bool
};

SpiteToggle.defaultProps = { checked: false, full: false };
